import React from 'react';
import { Sparkles, ShieldCheck, Truck, BadgeCheck } from 'lucide-react';
import SectionHeading from './SectionHeading';
import FeatureCard from './FeatureCard';

const FEATURES = [
  {
    icon: Sparkles,
    title: 'Freshly Cut',
    description: 'Fresh meat prepared daily to maintain quality and freshness in every order.',
    tone: 'mint',
  },
  {
    icon: BadgeCheck,
    title: 'Quality Checked',
    description: 'Every product is carefully inspected for quality before it reaches you.',
    tone: 'cream',
  },
  {
    icon: ShieldCheck,
    title: 'Hygienically Handled',
    description: 'Strict hygiene standards maintained throughout processing and packing.',
    tone: 'sage',
  },
  {
    icon: Truck,
    title: 'Fast Delivery',
    description: 'Quick and reliable local delivery, straight to your doorstep.',
    tone: 'white',
  },
];

const STATS = [
  { stat: '100%', title: 'Quality Checked', tone: 'mint' },
  { stat: 'Fresh', title: 'Every Day', tone: 'cream' },
  { stat: 'Fast', title: 'Delivery', tone: 'sage' },
];

const About = () => (
  <section id="about" className="py-24 bg-gradient-to-b from-emerald-50/60 via-white to-white overflow-hidden relative">
    <div
      className="absolute top-0 right-0 w-[26rem] h-[26rem] bg-emerald-200/20 rounded-full blur-3xl pointer-events-none -translate-y-1/3 translate-x-1/4"
      aria-hidden="true"
    />
    <div
      className="absolute bottom-0 left-0 w-80 h-80 bg-emerald-100/40 rounded-full blur-3xl pointer-events-none translate-y-1/3 -translate-x-1/4"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <SectionHeading
        eyebrow="Our Promise"
        title="Why Choose Us"
        description="Quality, hygiene and trust — built into every order, every day."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        {FEATURES.map((feature) => (
          <FeatureCard key={feature.title} {...feature} />
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {STATS.map((item) => (
          <FeatureCard key={item.title} {...item} />
        ))}
      </div>
    </div>
  </section>
);

export default About;
